<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" *ngIf="kivalasztott">
      <ion-button (click)="vissza()">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ng-container *ngIf="kivalasztott">Layout szerkesztő: {{stripElotagok(kivalasztott.azonosito)}} v{{kivalasztott.verzio}}</ng-container>
      <ng-container *ngIf="!kivalasztott">Nyomtatvány layout szerkesztő</ng-container>
    </ion-title>
    <ion-buttons slot="end" *ngIf="kivalasztott">
      <ion-button *ngIf="enykElerhetoBetolt" (click)="enykImport()" [disabled]="enykFeldolgozas" color="warning">
        <ion-icon slot="start" name="flash-outline"></ion-icon>
          {{ enykFeldolgozas ? 'Feldolgozás...' : 'XSD import' }}
      </ion-button>
      <ion-button (click)="ment()" color="success">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        Mentés
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- FÁJL LISTA -->
  <ng-container *ngIf="!kivalasztott">
    <div class="file-selector">
      <div class="file-selector__hint">Válassz nyomtatvány XML fájlt a layout szerkesztéséhez:</div>
      <div class="file-card" *ngFor="let s of fajlSablonok" (click)="kivalaszt(s)">
        <ion-icon name="document-text-outline"></ion-icon>
        <div class="file-card__info">
          <strong>{{stripElotagok(s.azonosito)}}</strong>
          <span class="badge">v{{s.verzio}}</span>
          <small *ngIf="s.adozoNev">{{s.adozoNev}}</small>
        </div>
        <ion-icon name="chevron-forward-outline" class="file-card__arrow"></ion-icon>
      </div>
      <div *ngIf="!fajlSablonok.length" class="file-selector__empty">
        Nincsenek XML sablonok. Tedd a .xml fájlokat a backend mappába.
      </div>
    </div>
  </ng-container>

  <!-- SZERKESZTŐ: 3 hasábos layout -->
  <div *ngIf="kivalasztott" class="editor" (click)="konfigMezo = null">

    <!-- BAL: PALETTA -->
    <div class="palette" (click)="$event.stopPropagation()">
      <div class="palette__header">
        <ion-icon name="list-outline"></ion-icon>
        Mezők
        <span class="palette__db">({{paletteMezok.length}})</span>
      </div>
      <div class="palette__hint">← Húzd egy sorba</div>
      <div
        cdkDropList
        id="palette-list"
        [cdkDropListData]="paletteMezok"
        [cdkDropListConnectedTo]="getAllFieldDropIds()"
        (cdkDropListDropped)="paletteDropped($event)"
        class="palette__list"
      >
        <div
          *ngFor="let pm of paletteMezok"
          cdkDrag
          [cdkDragData]="pm"
          class="palette__item"
          [class.palette__item--checkbox]="pm.tipusKod === 'F'"
          [class.palette__item--boxed]="pm.tipusKod === 'H'"
        >
          <ion-icon name="move-outline" class="drag-icon"></ion-icon>
          <div class="palette__item-body">
            <span class="palette__eazon">{{pm.eazon}}</span>
            <span class="palette__label">{{pm.label}}</span>
          </div>
          <span *ngIf="pm.tipusKod" class="type-chip">{{pm.tipusKod}}</span>
          <ng-template cdkDragPreview>
            <div class="drag-preview">{{pm.label || pm.eazon}}</div>
          </ng-template>
          <ng-template cdkDragPlaceholder>
            <div class="drag-placeholder-item"></div>
          </ng-template>
        </div>
        <div *ngIf="paletteMezok.length === 0" class="palette__empty">
          Minden mező be van helyezve.
        </div>
      </div>
    </div>

    <!-- KÖZÉP: CANVAS -->
    <div class="canvas">
      <!-- OLDAL FÜLEK -->
      <div class="oldal-tabsor" (click)="$event.stopPropagation()">
        <button
          *ngFor="let oldal of layout.oldalak; let oi = index"
          class="oldal-tab"
          [class.oldal-tab--aktiv]="aktivOldal?.id === oldal.id"
          (click)="aktivOldal = oldal; szerkesztettOldalId = null"
        >
          <input
            *ngIf="oldalSzerkesztesAktiv(oldal)"
            [(ngModel)]="oldal.cim"
            class="oldal-tab__input"
            (click)="$event.stopPropagation()"
            (blur)="szerkesztettOldalId = null"
            (keydown.enter)="szerkesztettOldalId = null"
          >
          <span *ngIf="!oldalSzerkesztesAktiv(oldal)" class="oldal-tab__cim">{{oldal.cim}}</span>
          <button class="oldal-tab__ikon" (click)="szerkesztettOldalId = oldal.id; aktivOldal = oldal; $event.stopPropagation()" title="Átnevez">✎</button>
          <button class="oldal-tab__ikon" (click)="oldalFel(oi); $event.stopPropagation()" [disabled]="oi === 0" title="Balra">←</button>
          <button class="oldal-tab__ikon" (click)="oldalJobb(oi); $event.stopPropagation()" [disabled]="oi === layout.oldalak.length - 1" title="Jobbra">→</button>
          <button class="oldal-tab__ikon oldal-tab__ikon--del" (click)="oldalTorol(oldal); $event.stopPropagation()" title="Törlés">×</button>
        </button>
        <button class="oldal-tab oldal-tab--add" (click)="oldalHozzaad(); $event.stopPropagation()">
          <ion-icon name="add-outline"></ion-icon>&nbsp;+ Oldal
        </button>
      </div>

      <div class="canvas__toolbar" (click)="$event.stopPropagation()">
        <ion-button size="small" (click)="blokkHozzaad()" [disabled]="!aktivOldal">
          <ion-icon slot="start" name="add-outline"></ion-icon>
          + Blokk (doboz)
        </ion-button>
        <span class="canvas__toolbar-hint">Kattints egy mezőre a beállítások panelhez →</span>
      </div>

      <div class="canvas__blocks">

        <div *ngFor="let blokk of aktivOldal?.blokkok; let bi = index" class="blokk">

          <!-- Blokk fejléc -->
          <div class="blokk__header" (click)="$event.stopPropagation()">
            <input [(ngModel)]="blokk.cim" class="blokk__cim-input" placeholder="Blokk neve...">
            <div class="blokk__header-actions">
              <button class="icon-btn" (click)="blokkFel(bi)" [disabled]="bi === 0" title="Blokk fel">↑</button>
              <button class="icon-btn" (click)="blokkLe(bi)" [disabled]="bi === (aktivOldal?.blokkok?.length ?? 0) - 1" title="Blokk le">↓</button>
              <button class="icon-btn icon-btn--danger" (click)="blokkTorol(blokk)" title="Blokk törlés">✕</button>
            </div>
          </div>

          <!-- Sorok -->
          <div class="blokk__body">
            <div *ngFor="let sor of blokk.sorok; let si = index" class="sor" (click)="$event.stopPropagation()">

              <!-- Sor vezérlők -->
              <div class="sor__controls">
                <button class="icon-btn icon-btn--sm" (click)="sorFel(blokk, si)" [disabled]="si === 0" title="Sor fel">↑</button>
                <button class="icon-btn icon-btn--sm" (click)="sorLe(blokk, si)" [disabled]="si === blokk.sorok.length - 1" title="Sor le">↓</button>
                <button class="icon-btn icon-btn--sm icon-btn--danger" (click)="sorTorol(blokk, sor)" title="Sor törlés">✕</button>
              </div>

              <!-- Mező drop zóna -->
              <div
                cdkDropList
                [id]="'row-' + sor.id"
                [cdkDropListData]="sor.mezok"
                [cdkDropListConnectedTo]="getAllFieldDropIds()"
                (cdkDropListDropped)="sorMezoDropped($event)"
                cdkDropListOrientation="horizontal"
                class="sor__drop"
                [class.sor__drop--empty]="!sor.mezok.length"
              >
                <div
                  *ngFor="let m of sor.mezok"
                  cdkDrag
                  [cdkDragData]="m"
                  class="canvas-mezo"
                  [class.canvas-mezo--aktiv]="konfigMezo?.eazon === m.eazon"
                  [class.canvas-mezo--checkbox]="m.tipus === 'checkbox'"
                  [class.canvas-mezo--boxed]="m.tipus === 'boxed'"
                  [class.canvas-mezo--dropdown]="m.tipus === 'dropdown'"
                  [class.canvas-mezo--textarea]="m.tipus === 'textarea'"
                  [style.flex]="m.szeles"
                  (click)="mezoKonfig(m, $event)"
                >
                  <ion-icon name="move-outline" class="drag-icon drag-icon--sm"></ion-icon>
                  <div class="canvas-mezo__body">
                    <span class="canvas-mezo__label">{{m.label || m.eazon}}</span>
                    <span class="canvas-mezo__eazon">{{m.eazon}}</span>
                    <span class="canvas-mezo__tipus tipus--{{m.tipus}}">{{m.tipus}}</span>
                  </div>
                  <button
                    class="canvas-mezo__del"
                    (click)="mezoTorol(sor, m); $event.stopPropagation()"
                    title="Visszaküldés a palettera"
                  >×</button>
                  <ng-template cdkDragPreview>
                    <div class="drag-preview">{{m.label || m.eazon}}</div>
                  </ng-template>
                  <ng-template cdkDragPlaceholder>
                    <div class="drag-placeholder-item drag-placeholder-item--horiz"></div>
                  </ng-template>
                </div>

                <div *ngIf="!sor.mezok.length" class="sor__empty-hint">
                  ← ide húzd a mezőt
                </div>
              </div>
            </div>

            <div *ngIf="!blokk.sorok.length" class="blokk__empty">
              Még nincs sor
            </div>

            <button class="add-sor-btn" (click)="sorHozzaad(blokk); $event.stopPropagation()">
              <ion-icon name="add-circle-outline"></ion-icon> Sor hozzáadása
            </button>
          </div>

        </div><!-- /blokk -->

      </div>

      <div *ngIf="!aktivOldal" class="canvas__empty">
        <ion-icon name="albums-outline"></ion-icon>
        <p>Hozz létre egy oldalt (fület) a &ldquo;+ Oldal&rdquo; gombbal, majd adj hozzá blokkokat.</p>
      </div>
      <div *ngIf="aktivOldal && !aktivOldal.blokkok.length" class="canvas__empty">
        <ion-icon name="construct-outline"></ion-icon>
        <p>Hozz létre egy blokkot (dobőz) a &ldquo;+ Blokk&rdquo; gombbal, adj hozzá sorokat, majd húzd rá a mezőket.</p>
      </div>
    </div><!-- /canvas -->

    <!-- JOBB: KONFIG PANEL -->
    <div class="konfig" [class.konfig--visible]="!!konfigMezo" (click)="$event.stopPropagation()">
      <ng-container *ngIf="konfigMezo">
        <div class="konfig__header">
          <ion-icon name="settings-outline"></ion-icon>
          Mező beállítások
          <button class="icon-btn konfig__close" (click)="konfigMezo = null">✕</button>
        </div>
        <div class="konfig__eazon">{{konfigMezo.eazon}}</div>

        <div class="konfig__body">

          <div class="konfig__row">
            <label class="konfig__label">Felirat</label>
            <input [(ngModel)]="konfigMezo.label" class="konfig__input" placeholder="Felülírható cimke">
          </div>

          <div class="konfig__row">
            <label class="konfig__label">Súgó / leírás</label>
            <input [(ngModel)]="konfigMezo.sugo" class="konfig__input" placeholder="Rövid magyarázat a mezőhöz">
          </div>

          <div class="konfig__row konfig__row--inline">
            <label class="konfig__label">Kötelező mező</label>
            <ion-checkbox [(ngModel)]="konfigMezo.kotelezo"></ion-checkbox>
          </div>

          <div class="konfig__szekciocim">Validáció</div>
          <div class="konfig__row">
            <label class="konfig__label">Regex minta</label>
            <input [(ngModel)]="konfigMezo.mintazat" class="konfig__input" placeholder="pl. [0-9+-]+">
          </div>
          <div class="konfig__row">
            <label class="konfig__label">Min hossz</label>
            <input type="number" [(ngModel)]="konfigMezo.minHossz" min="0" class="konfig__input konfig__input--short">
          </div>
          <div class="konfig__row">
            <label class="konfig__label">Max hossz</label>
            <input type="number" [(ngModel)]="konfigMezo.maxHossz" min="1" class="konfig__input konfig__input--short">
          </div>

          <div class="konfig__szekciocim">Számított mező</div>
          <div class="konfig__row">
            <label class="konfig__label">Számítás módja</label>
            <select [(ngModel)]="konfigMezo.szamitasTipus" class="konfig__select">
              <option value="nincs">Nincs</option>
              <option value="masol">Másolás másik mezőből</option>
              <option value="keplet">Képlet (&#123;EAZON&#125;)</option>
            </select>
          </div>

          <div class="konfig__row" *ngIf="konfigMezo.szamitasTipus === 'masol'">
            <label class="konfig__label">Forrás mező</label>
            <select [(ngModel)]="konfigMezo.forrasEazon" class="konfig__select">
              <option value="">Válassz mezőt...</option>
              <option *ngFor="let fm of osszesMezoForras()" [value]="fm.eazon">{{fm.eazon}} - {{fm.label}}</option>
            </select>
          </div>

          <div class="konfig__row" *ngIf="konfigMezo.szamitasTipus === 'keplet'">
            <label class="konfig__label">Képlet</label>
            <textarea [(ngModel)]="konfigMezo.keplet" class="konfig__input" rows="3" placeholder="pl. &#123;0A0001E001A&#125; / &#123;0A0001E006A&#125;"></textarea>
          </div>

          <div class="konfig__row konfig__row--inline" *ngIf="konfigMezo.szamitasTipus !== 'nincs'">
            <label class="konfig__label">Csak olvasható a kitöltőn</label>
            <ion-checkbox [(ngModel)]="konfigMezo.readonly"></ion-checkbox>
          </div>

          <div class="konfig__row">
            <label class="konfig__label">Típus</label>
            <select [(ngModel)]="konfigMezo.tipus" class="konfig__select">
              <option *ngFor="let t of tipusok" [value]="t.value">{{t.label}}</option>
            </select>
          </div>

          <div class="konfig__row">
            <label class="konfig__label">Szélesség (sor arány)</label>
            <select [(ngModel)]="konfigMezo.szeles" class="konfig__select">
              <option *ngFor="let sw of szelesOpciok" [value]="sw.value">{{sw.label}}</option>
            </select>
          </div>

          <div *ngIf="konfigMezo.tipus === 'boxed'" class="konfig__row">
            <label class="konfig__label">Karakterdobozok száma</label>
            <input
              type="number"
              [(ngModel)]="konfigMezo.kockaDb"
              min="1"
              max="30"
              class="konfig__input konfig__input--short"
            >
          </div>

          <ng-container *ngIf="konfigMezo.tipus === 'dropdown'">
            <div class="konfig__szekciocim">HTTP adatforrás</div>
            <div class="konfig__row">
              <label class="konfig__label">URL (GET kérés)</label>
              <input
                [(ngModel)]="konfigMezo.dropdownUrl"
                class="konfig__input"
                placeholder="pl. /api/tanulok?csak_aktiv=1"
              >
            </div>
            <div class="konfig__row">
              <label class="konfig__label">Érték kulcsa</label>
              <input
                [(ngModel)]="konfigMezo.dropdownValueKey"
                class="konfig__input"
                placeholder="pl. id"
              >
            </div>
            <div class="konfig__row">
              <label class="konfig__label">Megjelenített felirat kulcsa</label>
              <input
                [(ngModel)]="konfigMezo.dropdownLabelKey"
                class="konfig__input"
                placeholder="pl. nev"
              >
            </div>
            <div class="konfig__hint">
              A GET kérés JSON tömböt kell visszaadjon. A megadott kulcsokból épül fel az opciólista.
            </div>
          </ng-container>

        </div>
      </ng-container>

      <div *ngIf="!konfigMezo" class="konfig__placeholder">
        <ion-icon name="hand-left-outline"></ion-icon>
        <p>Kattints egy mezőre a beállítások szerkesztéséhez</p>
      </div>
    </div><!-- /konfig -->

  </div><!-- /editor -->

</ion-content>
